/**
 * Validate số điện thoại Việt Nam
 * Hỗ trợ: 10 số bắt đầu bằng 0, hoặc +84/84 theo sau 9 số
 */
export const validatePhoneNumber = (phone: string): boolean => {
  const cleaned = phone.replace(/[\s\-().]/g, "");
  return /^(0|\+84|84)(3[2-9]|5[25689]|7[06-9]|8[0-9]|9[0-9])\d{7}$/.test(cleaned);
};

/**
 * Validate mật khẩu
 * Tối thiểu 8 ký tự, gồm: 1 chữ hoa, 1 chữ thường, 1 số, 1 ký tự đặc biệt
 */
export const validatePassword = (password: string): boolean => {
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]).{8,}$/.test(password);
};

/**
 * Dùng cho Ant Design Form rule
 */
export const passwordRule = {
  validator: (_: any, value: string) => {
    if (!value || validatePassword(value)) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error("Mật khẩu tối thiểu 8 ký tự, gồm chữ hoa, chữ thường, số và ký tự đặc biệt")
    );
  },
};

/**
 * Dùng cho Ant Design Form rule
 */
export const phoneRule = {
  validator: (_: any, value: string) => {
    if (!value || validatePhoneNumber(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Số điện thoại không hợp lệ"));
  },
};
